import { reducer } from './reducer';
import { sagas } from './sagas';


export * from './actions';
export * from './hooks';

export const documents = {
    reducer,
    sagas,
};
